// VoK MUI base styles
import colors from "app/assets/theme/base/colors";
import boxShadows from "app/assets/theme/base/boxShadows";
import borders from "app/assets/theme/base/borders";

const {white} = colors;
const {cardBoxShadow} = boxShadows;
const {borderRadius} = borders;

const tableContainer = {
    styleOverrides: {
        root: {
            backgroundColor: white.main,
            boxShadow: cardBoxShadow,
            borderRadius: borderRadius.xl,
        },
    },
};

export default tableContainer;
